import { useEffect, useState, useCallback } from "react"
import styles from "./HowToWork.module.scss"
import apiMethods from "../../api/apiMethods"
import { Section } from "./Section"

export function HowToWorkPage({ config }) {
    const [rules, setRules] = useState()

    const fetchRules = useCallback(async () => {
        try {
            const { data } = await apiMethods.docs.getDocs()
            const rules = data?.data?.find((item) => item.type === "rules")
            setRules(rules || null)
        } catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        let cancelled = false

        const fetchRules = async () => {
            try {
                const { data } = await apiMethods.docs.getDocs()
                if (cancelled) return

                const found = data?.data?.find((item) => item.type === "rules")
                setRules(found || null)
            } catch (error) {
                if (cancelled) return
                console.log(error)
            }
        }

        fetchRules()

        return () => {
            cancelled = true
        }
    }, [])

    useEffect(() => {
        document.title = "Инструкция | Как пользоваться порталом"
    }, [])

    const rulesUrl = Boolean(rules?.url) ? rules.url : "/docs/zic_rules.pdf"

    return (
        <div className={styles.page}>
            <div className="wrapper">
                <p className={styles.heroTitle}>{config.greeting}</p>
                <h1 className={styles.heroSubtitle}>{config.title}</h1>

                <div className={styles.layout}>
                    <aside className={styles.sidebar}>
                        <nav className={styles.toc} aria-label="Содержание">
                            <h3 className={styles.tocTitle}>Содержание</h3>
                            <ol className={styles.tocList}>
                                {config.toc.map((item, i) => (
                                    <li key={item.id}>
                                        <a href={`#${item.id}`}>
                                            <span className={styles.tocNumber} aria-hidden="true">
                                                {String(i + 1).padStart(2, "0")}
                                            </span>
                                            <span className={styles.tocText}>{item.title}</span>
                                        </a>
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    </aside>

                    <main className={styles.content}>
                        <article className={styles.article}>
                            {config.sections.map((section) => (
                                <Section key={section.id ?? section.number} {...section} rulesUrl={rulesUrl} />
                            ))}

                            <section className={styles.finalBlock}>
                                <p className={styles.heroSubtitle}>Спасибо за участие в программе.</p>
                                <p className={styles.heroTitle}>Успешных продаж!</p>
                            </section>
                        </article>
                    </main>
                </div>
            </div>
        </div>
    )
}
